import React from "react";

import Header from "./Header";
import Footer from "./Footer";
export default () => {
  return (
      <>
        <Header/>
        <main>
            <div class="map-banner">
                <iframe id="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96652.27317354927!2d-74.33557928194516!3d40.79756494697628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3a82f1352d0dd%3A0x81d4f72c4435aab5!2sTroy+Meadows+Wetlands!5e0!3m2!1sen!2sbd!4v1563075599994!5m2!1sen!2sbd" allowfullscreen></iframe>
            </div>
            <section class="contact-section sec-padding">
                <div class="container">
                    <div class="contact-wrapper">
                        <div class="row g-4">
                            <div class="col-lg-7">
                                <div class="contact-content">
                                    <div class="title-box position-relative mb-0 pb-30">
                                        <div class="title-shape" style={{backgroundImage:`url('assets/img/shape/title-shape.png')`}}></div>
                                        <h4 class="sec-sub-title">Submit inquiry</h4>
                                        <h2 class="sec-title">Feel free to contact us</h2>                  
                                    </div>
                                    <form action="contact.php" id="contact-form" method="POST" class="contact-form-items">
                                        <div class="row g-4">
                                            <div class="col-lg-6">
                                                <div class="form-clt">
                                                    <input type="text" name="name" id="name" placeholder="First Name *"/>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-clt">
                                                    <input type="text" name="name" id="name2" placeholder="Last Name *"/>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-clt">
                                                    <input type="text" name="email" id="email" placeholder="E-mail *"/>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-clt">
                                                    <input type="text" name="website" id="website" placeholder="Web site *"/>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="form-clt">
                                                    <textarea name="message" id="message" placeholder="Message"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <button type="submit" class="theme-btn btn-style-one">
                                                <span class="txt">SEnd Message <i class="fa-light fa-circle-arrow-right ps-2"></i></span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Footer/>
      </>
  );
};
